import useScrollTrigger from "@mui/material/useScrollTrigger"
import React, {FC, useRef} from "react"
import {getWindow} from "../../utils/window"
import connect from "./connect"
import {StyledZoom, StyledFab, StyledTooltip} from "./components"
import {getPageOneUri} from "../../utils/urlBuilder"
import {TextModel} from "../../models/Text"

interface BackToTopProps {
    startPage: number
    text: TextModel
    loadFirstPage: (historyUrl: string) => void
}

export const BackToTop: FC<BackToTopProps> = ({startPage, text, loadFirstPage}: BackToTopProps) => {
    const window = useRef<any>()
    window.current = getWindow()

    const trigger = useScrollTrigger({
        target: window.current ?? undefined,
        disableHysteresis: true,
        threshold: window.current ? window.current.innerHeight : 0,
    })

    const handleClick = () => {
        if (startPage === 1) {
            window.current.scrollTo(0, 0)
        } else {
            loadFirstPage(getPageOneUri(window.current.location.toString()))
        }
    }

    return (
        <StyledZoom unmountOnExit in={trigger || startPage > 1}>
            <StyledFab data-testid="plp-back-to-top-btn" onClick={handleClick} aria-label={text.buttons.backToTop}>
                <StyledTooltip aria-label={text.buttons.backToTop}>{text.buttons.backToTop}</StyledTooltip>
            </StyledFab>
        </StyledZoom>
    )
}

export default connect(BackToTop)
